export default "__VITE_ASSET__ObVc_qFN__"